import { ColDef, ColumnState } from 'ag-grid-community';
import type { PmsPosition } from './pms-config.model';
import type { EventPriceType } from './pms-events-stream';

export type PmsGridColumns = ColumnState[];
export type PmsGridSelectionColumns = {
  colId: string;
  hidden: boolean;
  disabled: boolean;
  name: string;
  tooltip?: string;
  order: number;
};

export const CASH_ASSETTYPE = 'CASH';

export enum COLUMNS_NEEDED_FOR_REBALANCE {
  accountcode = 'accountcode',
  direction = 'direction',
}

export enum REBALANCE_COLUMN_KEYS {
  tgtpct = 'tgtpct',
  rebalancequantity = 'rebalancequantity',
  rebalancecost = 'rebalancecost',
}

export interface PmsGridColDef extends ColDef {
  field?: string;
  colId: string;
}

export const EVENT_STREAM_BUFFER_TIMEOUT = 1000;

export const EVENT_PRICE_STREAM_FIELDS = {
  mid: 'mark',
  undprc: 'undprc',
  delta: 'delta',
  gamma: 'gamma',
} as const satisfies Record<EventPriceType, keyof PmsPosition>;
